export const locale = {
  lang: 'en',
  data: {
    ERROR: {
      HTTP: {
        403: {
          'TITLE': '403 ERROR',
          'MESSAGE': 'You are not authorized to access this page.'
        }
      },
    },
  },
};
